import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import classNames from "classnames";
import { Column, Row } from "../../components/Row";
import { useCurrentBreakpoint } from "../../hooks/useCurrentBreakpoint";
import styles from "./PushBlockContentWrapper.module.scss";
export const PushBlockContentWrapper = ({ className, imgMobile, imgDesktop, alt, orientation, smallHeightOnMobile = false, renderImage, mobileOrientation = "bottom-text", isCarousel = false, renderContent = () => null, }) => {
    // TODO: temporary fix for source rare issue in browsers
    const { mainBreakpoint } = useCurrentBreakpoint();
    const isMobile = useMemo(() => ["xs", "sm"].includes(mainBreakpoint), [mainBreakpoint]);
    const isCentered = orientation === "centered";
    const columnMdSize = isCarousel
        ? 12
        : {
            centered: 12,
            "left-side-text-wide": 6,
            "right-side-text-wide": 6,
        }[orientation] || 4;
    const containerClasses = classNames(styles.container, {
        [styles.imageFirst]: ["right-side-text", "right-side-text-wide"].includes(orientation),
        [styles.centered]: isCentered,
        [styles.smallHeightOnMobile]: smallHeightOnMobile,
    });
    const a11yProps = {};
    if (isCentered && alt) {
        a11yProps.role = "img";
        a11yProps["aria-label"] = alt;
    }
    return (_jsxs("div", { "data-testid": "pushBlock", style: {
            "--image-src-mobile": `url("${imgMobile || imgDesktop}")`,
            "--image-src-desktop": `url("${imgDesktop}")`,
        }, className: classNames(className, { [styles.smallHeightOnMobile]: smallHeightOnMobile }), children: [_jsx("div", { ...a11yProps }), _jsxs(Row, { className: containerClasses, dataTestId: "pushBlockRow", children: [_jsx(Column, { xs: 12, md: columnMdSize, className: classNames(styles.textColumn, {
                            [styles.textOrder]: mobileOrientation === "bottom-text",
                            [styles.carousel]: mobileOrientation === "bottom-text" && isCarousel,
                        }), children: renderContent() }), !isCentered && (_jsx(Column, { xs: 12, md: isCarousel ? 12 : ["left-side-text-wide", "right-side-text-wide"].includes(orientation) ? 6 : 8, className: classNames(styles.imageColumn, {
                            [styles.hideOnMobile]: smallHeightOnMobile,
                            [styles.imageOrder]: mobileOrientation === "bottom-text",
                            [styles.carousel]: mobileOrientation === "bottom-text" && isCarousel,
                        }), children: _jsx("div", { className: styles.imageSection, "data-testid": "pushblockImageWrapper", children: renderImage ? (renderImage({ imgDesktop, imgMobile, alt })) : (_jsx("img", { "data-testid": "pushBlockImage", src: isMobile ? imgMobile || imgDesktop : imgDesktop, alt: alt })) }) }))] })] }));
};
//# sourceMappingURL=PushBlockContentWrapper.js.map